export default __webpack_public_path__ + "static/media/linhaamarela.1b22f67a.svg";